/**
 * Front end code initialization
 */

/**
 * Internal dependencies
 */
import quantityChange from './quantityChange';

/**
 * Initialize the application when the DOM is ready.
 *
 * @requires quantityChange
 */
const init = () => {
	// Initialize quantityChange
	quantityChange();
};

export default init;
